export default {
  en: {
    title: "Basic Calls Configurations",
    tab_reasons: "Reasons",
    tab_caller_info: "CRM",
    tab_call_rating: "Call Rating",
    tab_call_back: "Call Back",
    tab_call_campaign: "Campaign Calls",
    tab_welcome_message: "Welcome",
    tab_settings: "Settings",
    settings: {
      auto_answer_label: "Auto Answer",
      auto_answer_description: "Automatically answer incoming calls for all agents",
      toggle_progress: "Updating auto answer setting...",
    },
    transcription: "Transcription",
    waiting_for_transcription: "Waiting for transcription data...",
    calls_logs: "Calls Logs",
    caller_profile: "Client Info",
    minimise: "Minimise",
    reasons: {
      title: "Call Reason",
      pick_reason: "Pick Reason",
      head_title: "Reasons List",
      add_reason_title: "New Call Reason",
      add_reason_subtitle: "Child For Reason {0}",
      add_reason_label: "Reason",
      add_reason_btn: "Add",
      create_reason_btn: "Creat New Reason",
      reason_sibling_exist: "reason already exist as sibling!",
      reason_missing: "reason is requierd",
      reason_empty: "reason is empty",
      reason_minimum: "reason should be minimum of 3 characters",
      update_reason_btn: "Update",
      cancel_reason_btn: "Cancel",
      add_child_btn: "Add Child",
      enable_reason_btn: "Enable",
      disable_reason_btn: "Disable",
      edit_reason_btn: "Edit",
      delete_reason_btn: "Delete",
      delete_pause_message: "Reason {name} Has Children",
      no_previous_calls: "No previous calls",
      add_reason: "Add Reason",
      save_reason: "Save Reason",
      saving: "Saving...",
      reason_changed: "reason changed",
      no_calls_description: "No previous call history found for this number",
      no_reasons: "No call reasons configured",
      no_reasons_description:
        "Ask your administrator to add call reasons before tagging this call",
    },

    call_rating: {
      title: "Calls And Agents Rating Management",
      IVR_rating_title: "IVR Sitting",
      ivr_tab: "IVR",
      enable: "Enabled",
      disable: "Disabled",
      skills_title: "Queues",
      rating_range_title: "Range",
      range_start_label: "Range Start",
      range_start_error: "invalid range start",
      range_end_label: "Range End",
      satisfy_score_label: "satisfaction score",
      range_end_error: "invalid range end",
      IVR_rating_update_btn: "update ivr settings",
      audio_rating_title: "Audio Messages",
      audio_rating_ask_label: "Call/Agent rating message",
      audio_invalid_label: "invalid digit message",
      audio_thank_you_label: "Thank you message",
      audio_upload_btn: "Upload",
      range_error: "invalid range scale",
      error_rating_no_updates: "no changes to be updated",
      init_rating: "initializing rating....",
      rating_update_progress: "updating rating....",
      audio_rating_rule: "Audio file must be {size} or smaller.",
      audio_type_rule: "Unsupported file type. Please choose an audio file.",
      audio_hint: "Audio file, up to {size}.",
      omni_rating_title: "Omni Conversations Rating",
      omni_tab: "Omni Channel",
      omni_message_title: "Omni Rating Request Message",
      omni_message_check_label: "Change Rating Message",
      omni_message_label: "rating message",
      omni_rating_update_btn: "update omni settings",
      enable_question_label: "Enable Question",
      is_csat_label: "Is CSAT",
      question_message_label: "Question",
      question_type_label: "Type",
      question_type_yes_no: "Yes/No",
      question_type_1_5: "1-5",
      question_type_0_9: "NPS (0-9)",
      question_type_1_3: "1-3",
      en_audio_label: "English Audio File",
      ar_audio_label: "Arabic Audio File",
      update_btn: "Update",
      upload_progress: "Uploading audio file....",
      save: "Save",
      no_audio: "No audio uploaded",
      choose_audio: "Choose file",
      empty: "No rating questions",
    },
    phone: {
      campaign_call: "Campaign call",
      campaign_call_named: "Campaign: {campaign}",
      queue_call: "Queue: {queue}",
      take_next_call_btn: "Ready For Next Call",
      hold_btn: "Hold",
      unhold_btn: "Unhold",
      hangup_btn: "Hangup",
      mute_btn: "Mute",
      unmute_btn: "Unmute",
      answer_btn: "Answer",
      forward_btn: "Forward",
      make_forward_btn: "Forward Call To {skill}",
      session_title: {
        in_line: "In line/",
        incoming: "Incoming ...",
        dialing: "Dialing ...",
        holding: "Holding ...",
        muting: "Muting ...",
        phone: "PHONE",
      },
      dial_text_label: "Phone",
      dial_btn: "Call",
      history_list_btn: "recent history",
      empty_history: "No calls yet...",
      invalid_dialed_text: "Invalid Number",
      call_list_btn: "Call {number}",
      whispering: "Whispering",
      dialpad_btn: "Dialpad",
      transfer_btn: "Transfer",
      transfer_to_queue: "Transfer to Queue",
      select_queue: "Select Queue",
      cancel_transfer: "Cancel",
      select_mic: "Select Microphone",
      no_mics: "No microphones found",
      mic_switch_error: "Couldn't switch microphone. Please try another device.",
      default_mic: "Microphone",
    },
    welcome_message: {
      title: "Manage Starting Welcome Message",
      no_message: "No message is set!",
      remove_btn: "Remove",
      file_label: "upload new welocme message",
      upload_btn: "Uplaod Audio",
      progress_welcome: "Processing welcome message....",
      progress_remove: "Removing welcome message....",
      file_required: "class file is required",
      file_invalid: "Invalid file",
      file_max_size: "maximum file size should be 6MB",
    },
    caller_info: {
      title: "Manage Customer Caller INFO",
      external_crm_check: "is seperate CRM",
      local_crm_create_check: "has info creation",
      manage_crm_btn: "Manage Info Create",
      local_ticket_create_check: "has ticket creation",
      manage_ticket_button: "Manage Tickets Create",
      update_settings_btn: "Update CRM & Ticketing Settings",
      init_msg: "initializing info management....",
      no_updates_msg: "no changes to be udated!",
      info_creation_title: "Call Center Customer Info Creation",
      ticket_creation_title: "Call Center Ticket Creation",
      info_create_fields_tab: "Create/Edit Customer CRM",
      ticket_create_fields_tab: "Create/Edit Tickets Fields",
      view_fields_tab: "View Fields",
      label_field_create_mod: "New Field",
      label_field_update_mod: "Update Field",
      key_title_label: "Key",
      key_label: "new field key",
      mandatory_check: "is mandatory",
      label_title_label: "labels",
      type_title_label: "Field Type",
      text_type_tab: "Text",
      number_type_tab: "Number",
      datetime_type_tab: "Datetime",
      single_type_tab: "Single Select",
      multiple_type_tab: "Multiple Select",
      text_type_label: "new field key as text",
      text_type_value: "Example new field",
      number_type_label: "new field key as number",
      number_type_value: "12345",
      datetime_type_placeholder: "new datetime field",
      single_type_label: "Single Select Field",
      single_select_text_label: "Single Select Field Value",
      add_select_value_btn: "Add",
      multiple_type_label: "Multiple Select Field",
      multiple_select_text_label: "Multiple Select Field Value",
      add_new_field_btn: "Add New Field",
      update_field_btn: "Update Field",
      cancel_btn: "Cancel",
      delete_btn: "Delete",
      edit_btn: "Edit",
      update_info_field_creation_btn: "Update CRM Creation",
      update_ticket_field_creation_btn: "Update Ticketing Creation",
      mandatory_msg: "field is mandatory",
      delete_progress_msg: "deleting field .....",
      process_progress_msg: "processing fields .....",
      empty_key_msg: "empty field key!",
      key_exist_msg: "key field exist!",
      empty_label_msg: "empty field label!",
      empty_list_msg: "empty field list!",
      invalid_field_msg: "invalid field",
      create_new_crm_btn: "Create New CRM",
      no_caller_info: "No caller info found!",
    },
    call_back: {
      abandoned_title: "Abandoned Calls",
      offtime_title: "Offtime Calls",
      settings_label: "Settings",
      enable_abandoned_label: "Enable abandoned calls",
      retry_label: "Retry Limit",
      skills_label: "Queues",
      update_btn: "Update Configurations",
      callback_progress_msg: "processing callback confs",
      enable_offtime_label: "Enable offtime calls",
    },
    campaign_calls: {
      customer_num_label: "Customer Number",
      add_number_btn: "Add Number",
      file_checkbox_label: "upload with a file",
      file_label: "txt file with the numbers list",
      call_btn: "Make Calls",
      invalid_number_msg: "invalid number format",
      number_exist_msg: "number already added",
      list_empty_msg: "no number was added",
      no_file_msg: "file error or not recognized",
      empty_file_msg: "file is empty",
      invalid_number_in_file_msg: "file contains invalid number",
    },
  },
  ar: {
    title: "الإعدادات الأساسية للمكالمات",
    tab_reasons: "أسباب المكالمات",
    tab_caller_info: "إعدادات العميل",
    tab_call_rating: "تقييم الأداء",
    tab_welcome_message: "رسالة الإستقبال",
    tab_settings: "الإعدادات",
    settings: {
      auto_answer_label: "الرد التلقائي",
      auto_answer_description: "الرد التلقائي على المكالمات الواردة لجميع الموظفين",
      toggle_progress: "جاري تحديث إعداد الرد التلقائي...",
    },
    transcription: "النصوص المكتوبة",
    waiting_for_transcription: "في انتظار النصوص المكتوبة...",
    calls_logs: "سجلات المكالمات السابقة",
    caller_profile: "معلومات العميل",
    minimise: "تصغير",
    reasons: {
      title: "سبب الاتصال",
      pick_reason: "اختر السبب",
      head_title: "قائمة أسباب المكالمات",
      add_reason_title: "سبب مكالمة جديد",
      add_reason_subtitle: "عنصر فرعي للسبب {0}",
      add_reason_label: "سبب مكالمة",
      add_reason_btn: "إضافة",
      create_reason_btn: "إضافة سبب",
      reason_sibling_exist: "القيمة موجودة مسبقا كعنصر مجاور",
      reason_missing: "القيمة غير موجودة",
      reason_empty: "القيمة فارغة",
      reason_minimum: "أقل قيمة من 3 أحرف",
      update_reason_btn: "تحديث",
      cancel_reason_btn: "إلغاء",
      add_child_btn: "إضافة فرع",
      enable_reason_btn: "تفعيل",
      disable_reason_btn: "إيقاف",
      edit_reason_btn: "تعديل",
      delete_reason_btn: "مسح",
      delete_pause_message: "السبب {name} لديه أفرع ثانوية",
      no_previous_calls: "لا يوجد مكالمات سابقة",
      save_reason: "حفظ السبب",
      saving: "جاري الحفظ....",
      reason_changed: "تم تغيير السبب",
      no_calls_description: "لا يوجد تاريخ مكالمات سابقة لهذا الرقم",
      no_reasons: "لا توجد أسباب مكالمات",
      no_reasons_description:
        "يرجى التواصل مع المسؤول لإضافة أسباب المكالمات قبل تصنيف هذه المكالمة",
      add_reason: "إضافة سبب",
    },

    call_rating: {
      title: "إدارة تقييم الموظفيين والمكالمات",
      IVR_rating_title: "إعدادات الرد الآلي (IVR)",
      ivr_tab: "الرد الآلي",
      enable: "مفعّلة",
      disable: "موقوفة",
      skills_title: "المجموعات",
      rating_range_title: "نطاق التقييم",
      range_start_label: "من",
      range_start_error: "قيمة النطاق غير صحيحة",
      range_end_label: "إلي",
      satisfy_score_label: "درجة الرضا",
      range_end_error: "قيمة النطاق غير صحيحة",
      IVR_rating_update_btn: "تحديث إعدادات الرد الآلي",
      audio_rating_title: "ملفات التقييم الصوتية",
      audio_rating_ask_label: "الملف لطلب تقييم المكالمة/الموظف",
      audio_invalid_label: "الملف في حالة إدخال خاطئ",
      audio_thank_you_label: "ملف شكر أو تأكيد مشاركة التقييم",
      audio_upload_btn: "تحميل",
      range_error: "قيم خاطئة لنطاق التقييم",
      error_rating_no_updates: "لا يوجد تغيير ليتم التحديث",
      init_rating: "تهيئة التقييم....",
      rating_update_progress: "تحديث التقييم......",
      audio_rating_rule: "يجب ألا يزيد حجم الملف الصوتي عن {size}.",
      audio_type_rule: "نوع الملف غير مدعوم. الرجاء اختيار ملف صوتي.",
      audio_hint: "ملف صوتي، بحد أقصى {size}.",
      omni_rating_title: "تقييم محادثات وسائل التواصل",
      omni_tab: "وسائل التواصل",
      omni_message_title: "رسالة طلب التقييم",
      omni_message_check_label: "تغيير الرسالة",
      omni_message_label: "رسالة التقييم",
      omni_rating_update_btn: "تحديث اعدادات التقييم",
      enable_question_label: "تفعيل السؤال",
      is_csat_label: "هل هو CSAT",
      question_message_label: "السؤال",
      question_type_label: "النوع",
      question_type_yes_no: "نعم/لا",
      question_type_1_5: "1-5",
      question_type_0_9: "NPS (0-9)",
      question_type_1_3: "1-3",
      en_audio_label: "ملف الصوت الإنجليزي",
      ar_audio_label: "ملف الصوت العربي",
      update_btn: "تحديث",
      upload_progress: "تحميل الملف الصوتي....",
      save: "حفظ",
      no_audio: "لا يوجد ملف صوتي",
      choose_audio: "اختر ملفًا",
      empty: "لا توجد أسئلة تقييم",
    },
    phone: {
      campaign_call: "مكالمة حملة",
      campaign_call_named: "حملة: {campaign}",
      queue_call: "المجموعة: {queue}",
      take_next_call_btn: "مستعد لإستقبال المكالمة التالية",
      hold_btn: "تثبيت",
      unhold_btn: "تشغيل",
      hangup_btn: "إغلاق",
      mute_btn: "صمت",
      unmute_btn: "صوت",
      answer_btn: "رد",
      forward_btn: "تحويل",
      make_forward_btn: "تحويل المكالمة إلى {skill}",
      session_title: {
        in_line: "في الخط/",
        incoming: "واردة....",
        dialing: "إتصال....",
        holding: "تثبيت....",
        muting: "صامت.....",
        phone: "هاتف",
      },
      dial_text_label: "رقم الهاتف",
      dial_btn: "إتصل",
      history_list_btn: "آخر مكالمات",
      empty_history: "لا يوجد مكالمات بعد",
      invalid_dialed_text: "رقم خاطئ",
      call_list_btn: "اتصل على {number}",
      whispering: "توجيه",
      dialpad_btn: "لوحة الاتصال",
      transfer_btn: "تحويل",
      transfer_to_queue: "تحويل إلى مجموعة",
      select_queue: "اختر المجموعة",
      cancel_transfer: "إلغاء",
      select_mic: "اختر الميكروفون",
      no_mics: "لا يوجد ميكروفون",
      mic_switch_error: "تعذّر تغيير الميكروفون. جرّب جهازاً آخر.",
      default_mic: "ميكروفون",
    },
    welcome_message: {
      title: "إدارة الرسالة الإفتتاحية للنظام",
      no_message: "لم يتم تحديد رسالة",
      remove_btn: "إزالة",
      file_label: "إضافة رسالة افتتاحية جديدة",
      upload_btn: "تحميل",
      progress_welcome: "جاري معالجة الرسالة......",
      progress_remove: "جاري مسح الرسالة.......",
      file_required: "الملف الصوتي اجباري",
      file_invalid: "ملف خاطئ",
      file_max_size: "الحجم الأقصى للملف هو 6MB",
    },
    caller_info: {
      title: "إدارة بيانات المتصل",
      external_crm_check: "نظام CRM خارجي",
      local_crm_create_check: "دعم انشاء بيانات العميل",
      manage_crm_btn: "إدارة إنشاء بيانات العميل",
      local_ticket_create_check: "دعم انشاء بلاغات",
      manage_ticket_button: "إدارة انشاء البلاغات",
      update_settings_btn: "تحديث الاعدادات",
      init_msg: "تهيئة ادارة البيانات.....",
      no_updates_msg: "لا يوجد تغييرات",
      info_creation_title: "اعدادت انشاء بيانات العميل",
      ticket_creation_title: "اعدادات انشاء البلاغات",
      info_create_fields_tab: "انشاء/تعديل حقول البيانات",
      ticket_create_fields_tab: "انشاء/تعديل الحقول",
      view_fields_tab: "عرض الحقول",
      label_field_create_mod: "حقل جديد",
      label_field_update_mod: "تعديل الحقل",
      key_title_label: "المعرّف",
      key_label: "معرف الحقل الجديد",
      mandatory_check: "إلزامي",
      label_title_label: "عناوين الحقول",
      type_title_label: "نوع الحقل",
      text_type_tab: "نص",
      number_type_tab: "رقم",
      datetime_type_tab: "زمن",
      single_type_tab: "اختيار مفرد",
      multiple_type_tab: "اختيار متعدد",
      text_type_label: "الحقل الجديد كنص",
      text_type_value: "مثال: الحقل الجديد",
      number_type_label: "الحقل الجديد كرقم",
      number_type_value: "12345",
      datetime_type_placeholder: "حقل زمن جديد",
      single_type_label: "حقل الاختيار المفرد",
      single_select_text_label: "قيمة في الختيار المفرد",
      add_select_value_btn: "إضافة",
      multiple_type_label: "حقل الاختيار المتعدد",
      multiple_select_text_label: "قيمة حقل الاختيار المتعدد",
      add_new_field_btn: "إضافة حقل جديد",
      update_field_btn: "تعديل الحقل",
      cancel_btn: "إلغاء",
      delete_btn: "حذف",
      edit_btn: "تعديل",
      update_info_field_creation_btn: "تحديث حقول الإنشاء",
      update_ticket_field_creation_btn: "تحديث حقول الإنشاء",
      mandatory_msg: "الحقل إلزامي",
      delete_progress_msg: "جاري مسح الحقل......",
      process_progress_msg: "جاري المعالجة.......",
      empty_key_msg: "معرف الحقل غير صحيح",
      key_exist_msg: "معرف الحقل موجود مسبقا",
      empty_label_msg: "عنوان الحقل غير صحيح",
      empty_list_msg: "قائمة الاختيار فارغة",
      invalid_field_msg: "الحقل خاطئ",
      no_caller_info: "لا يوجد معلومات للعميل",
    },
    call_back: {
      abandoned_title: "المكالمات الفائته",
      offtime_title: "المكالمات خارج الدوام",
      settings_label: "الضبط",
      enable_abandoned_label: "تفعيل للمكالمات الفائته",
      retry_label: "عدد المحاولات",
      skills_label: "المجموعات",
      update_btn: "تحديث الإعدادات",
      callback_progress_msg: "جاري المعالجة",
      enable_offtime_label: "تفعيل للمكالمات خارج الدوام",
    },
    campaign_calls: {
      customer_num_label: "رقم العميل",
      add_number_btn: "إضافة رقم",
      file_checkbox_label: "تحميل بواسطة ملف",
      file_label: "ملف txt يحتوي على قائمة الأرقام",
      call_btn: "ابدأ الإتصال",
      invalid_number_msg: "رقم غير صحيح",
      number_exist_msg: "الرقم موجود مسبقا",
      list_empty_msg: "لم يتم اضافة رقم",
      no_file_msg: "خطا بالملف",
      empty_file_msg: "الملف فارغ",
      invalid_number_in_file_msg: "الملف يحتوي على رقم خاطئ",
    },
  },
};
